// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchaseButton_container__j6P6y","icon":"PurchaseButton_icon__3WZTw"};